export default __webpack_public_path__ + "static/media/BetRaiseFlash.3a10cf65.wav";